import React, { useState } from "react";
import * as dateFNS from 'date-fns';
import swal from "sweetalert";
import { Form, Input, FormField, FormGroup, Button, Checkbox } from "semantic-ui-react";

import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import Footer from "../../../../components/Footer";

import { producaov2 } from "../../../../services/apis";

import { Container, Box, Header, FormBlock, Notes } from "./styles";


const RelatorioPagamentosFututos = () => {
  document.title = "Painel Administrativo | Grupo Voitto";

  const [dataInicio, setDataInicio] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [reportLink, setReportLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const generateReport = async () => {
    if(!dataInicio || !dataFinal) {
      return swal("Período da pesquisa obrigatório", "Atualize o período do relatório e tente novamente", "warning");
    }

    setLoading(true);

    try {
      const response = await producaov2.post('/admin/reports/pagamentos-futuros', {
        startPeriod: dataInicio,
        endPeriod: dataFinal,
      });
  
      setReportLink(response.data.url);
    } catch(error) {
      swal('Houve um erro ao gerar o relatorio', 'Contate TI para verificar o problema', 'error');
    } finally {
      setLoading(false);
    }
  }

  const handleDownloadReport = () => {
    setReportLink(null);
  }

  return (
    <div style={{width: "100vw", paddingLeft:"250px"}}>

      <AdminMenu />
      <Container>
        <Header>Relatório de Pagamentos Futuros</Header>
        <Box>
          <Form>
            <FormBlock>
              <p>Selecionar período</p>
              <FormField>
                A partir de
                <Input
                  onChange={(e) => setDataInicio(e.target.value)}
                  type="date"
                  min={dateFNS.format(new Date(), 'yyyy-MM-dd')}
                />
                até
                <Input
                  onChange={(e) => setDataFinal(e.target.value)}
                  type="date"
                  min={dataInicio ? dateFNS.format(dateFNS.addDays(new Date(dataInicio), 2), 'yyyy-MM-dd') : dateFNS.format(new Date(), 'yyyy-MM-dd')}
                />
              </FormField>
            </FormBlock>

            <FormGroup>
              {reportLink ? (
                <Button
                  as="a"
                  href={reportLink}
                  onClick={handleDownloadReport}
                  style={{ minWidth: "80px" }}
                  color="green"
                >
                  Baixar Relatório
                </Button>
              ) : (
                <Button
                  color="orange"
                  onClick={generateReport}
                  loading={loading}
                >
                  Gerar Relatório
                </Button>
              )}
            </FormGroup>
            <ul style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem', maxWidth: '30rem' }}>
              <li style={{ listStylePosition: 'inside' }}>Assinaturas que não possuem a primeira parcela paga são desconsideradas</li>
              <li style={{ listStylePosition: 'inside' }}>Boletos que não possuem o primeiro boleto pago são desconsiderados</li>
            </ul>
          </Form>
        </Box>
      </Container>
      <Footer />
    </div>
  );
};

export default RelatorioPagamentosFututos;
